import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

/* Services */
import { AuthenticationService } from '../services/authentication.service';

/* View Models */
import { ActivateAccountViewModel } from '..//viewmodels/activate-account-viewmodel';
import { PasswordComplexityViewModel } from '..//viewmodels/password-complexity-viewmodel';

@Component({
  selector: 'app-activate-account-cmp',
  templateUrl: './activation-request.component.html',
  styleUrls: ['./activation-request.component.scss'],
})
export class AccountActivationComponent {
  activateAccountVM: ActivateAccountViewModel;
  activationSuccessful = false;
  accountActivationMessage = '';
  passwordComplexity: PasswordComplexityViewModel;
  closeResult: string;
  showPassword = false;
  showConfirmPassword = false;
  checkingToken = true;
  tokenValid = false;

  /* Constructor */
  constructor(
    private modalService: NgbModal,
    private authenticationService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe((params) => {
      // console.log(params);
      if (params['token'] !== undefined) {
        this.activateAccountVM = new ActivateAccountViewModel();
        this.activateAccountVM.token = params['token'];
        this.checkTokenValid();
      } else {
        this.router.navigate(['/login']);
      }
    });
  }

  checkTokenValid() {
    this.checkingToken = true;
    this.authenticationService.checkActivationTokenValid(this.activateAccountVM).subscribe(
      (isValid) => {
        this.tokenValid = !!isValid;
        this.checkingToken = false;
      },
      (error) => {
        // Fail closed - if we can't confirm the token's still good, don't
        // let the user fill in a password only to be told at the end.
        this.tokenValid = false;
        this.checkingToken = false;
      }
    );
  }

  onAccountActivate() {
    this.authenticationService.activateAccount(this.activateAccountVM).subscribe(
      (resp) => {
        this.activationSuccessful = resp.successful;
        this.accountActivationMessage = resp.message;

        if (resp.successful) {
          setTimeout(() => this.router.navigate(['/login']), 2500);
        }
      },
      (error) => {
        // An HTTP-level failure (network/500/timeout) rather than the
        // normal {successful:false} payload above - without this the
        // button would otherwise just silently do nothing.
        this.activationSuccessful = false;
        this.accountActivationMessage = 'Something went wrong! Please try again.';
      }
    );
  }

  openModal(content) {
    this.modalService.open(content, { centered: true });
  }
}
